<script>
export default {
  name: 'ProviderInformationTab',
  props: {
    provider: {
      type: Object,
      required: true,
    },
  },
  computed: {
    status() {
      return this.provider.active ? 'active' : 'inactive'
    },
  },
}
</script>

<template>
  <data-box
    header="Provider Details"
    :status="status"
  >
    <data-list>
      <dt>Date Created</dt>
      <dd>{{ provider.createdAt | dateTime }}</dd>

      <dt>Last Updated</dt>
      <dd>{{ provider.updatedAt | dateTime }}</dd>

      <dt>Provider ID</dt>
      <dd>{{ provider.id }}</dd>

      <dt>Provider Name</dt>
      <dd>{{ provider.name }}</dd>

      <dt>Provider Description</dt>
      <dd>{{ provider.description || '-' }}</dd>

      <!-- <dt>2FA</dt>
      <dd>{{ provider['2fa'] }}</dd> -->

      <dt>Time Zone</dt>
      <dd>{{ provider.timezone || '-' }}</dd>
    </data-list>
  </data-box>
</template>
